// Main entry point for offline infrastructure
// This provides a clean API for the rest of the application

// Initialize database on import
import { db } from './db/index.js';
import { multiTabCoordinator } from './services/multi-tab-coordination.service.js';
import { recoveryManager } from './utils/recovery.js';
import { offlineStateService } from './services/offline-state.service.js';
import { cacheDebugLog } from './utils/cache-debug.js';
import { syncEngine } from './sync/engine/sync-engine.js';

// Initialize database
db.initialize().catch(error => {
  console.error('[Offline] Database initialization failed:', error);
});

// Initialize multi-tab coordination
multiTabCoordinator.initialize();

// Start reconnect / queue processing (subscribes to online + interval)
syncEngine.initialize();

// Listen for background-sync events forwarded by the service worker.
// When the SW wakes after connectivity returns, it posts a BACKGROUND_SYNC
// message so the sync engine can replay queued mutations immediately.
if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data?.type === 'BACKGROUND_SYNC') {
      console.log('[Offline] SW background sync forwarded, triggering forceSync');
      syncEngine.forceSync();
    }
  });
}

// Hydrate critical data on app start
const hydrateCriticalData = async () => {
  if (import.meta.env.VITE_DISABLE_HYDRATE === 'true') {
    return;
  }
  try {
    if (!offlineStateService.isCurrentlyOnline()) {
      console.log('[Offline] Hydrating critical data for offline mode');
      cacheDebugLog('hydrate-critical-start', {});
    }
  } catch (error) {
    console.error('[Offline] Hydration failed:', error);
  }
};

hydrateCriticalData();

// Re-export everything for convenience
export * from './types/index.js';
export * from './db/index.js';
export * from './cache/index.js';
export * from './services/index.js';
export * from './hooks/index.js';
export * from './queue/index.js';
export * from './utils/index.js';
export * from './config/offline-config.js';
